<template>
  <el-container style="height: 100vh" class="box-container">
    <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
      <el-menu
        :default-openeds="['1', '2', '3']"
        :unique-opened="false"
        :default-active="$route.path"
        @select="toUrl"
      >
        <el-submenu index="1" v-if="seeNewoperate">
          <template slot="title"
            ><i class="el-icon-data-analysis"></i>顾问端</template
          >
          <el-menu-item
            v-for="(item, index) in navList"
            :key="index"
            :index="item.url"
          >
            {{ item.title }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="2" v-if="seeNewoperate">
          <template slot="title"
            ><i class="el-icon-data-analysis"></i>客户端</template
          >
          <el-menu-item
            v-for="(item, index) in navList2"
            :key="index"
            :index="item.url"
          >
            {{ item.title }}
          </el-menu-item>
        </el-submenu>
        <el-submenu index="3" v-if="seeSecoperate">
          <template slot="title"
            ><i class="el-icon-data-analysis"></i>经纪人端</template
          >
          <el-menu-item
            v-for="(item, index) in navList3"
            :key="index"
            :index="item.url"
          >
            {{ item.title }}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      seeNewoperate: true,
      seeSecoperate: true,
      navList: [
        {
          title: "总表",
          url: "/newOperateTeam/summaryTable",
        },
        {
          title: "审核",
          url: "/newOperateTeam/examine",
        },
        {
          title: "分享",
          url: "/newOperateTeam/share",
        },
        {
          title: "加分",
          url: "/newOperateTeam/addScore",
        },
        {
          title: "其他",
          url: "/newOperateTeam/other",
        },
      ],
      navList2: [
        {
          title: "总表",
          url: "/newOperateTeam/customerSumTable",
        },
        {
          title: "分享",
          url: "/newOperateTeam/customerShare",
        },
        {
          title: "群聊客服",
          url: "/newOperateTeam/customerGroupchat",
        },
        {
          title: "话题",
          url: "/newOperateTeam/customerTopic",
        },
      ],
      navList3: [
        {
          title: "相关功能",
          url: "/newOperateTeam/brokerIndex",
        },
        {
          title: "问答",
          url: "/newOperateTeam/customerQuestion",
        },
      ],
    };
  },
  created() {
    let type = sessionStorage.getItem("user_other_type") || "";
    if (type && type == "新房运营") {
      this.seeSecoperate = false;
    } else if (type && type == "二手房运营") {
      this.seeNewoperate = false;
    }
  },
  methods: {
    toUrl(indexPath) {
      this.$router.replace(indexPath);
    },
  },
};
</script>
<style scoped>
.box-container {
  border-top: 1px solid #eee;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/page/newOperateTeam/index.vue